import PropTypes from 'prop-types'

const SettingsHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

SettingsHeader.defaultProps = {
    title: 'Settings',
}

SettingsHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default SettingsHeader
